export default {
  title: {
    index: 'RPA看板',
    task: {
      detail: '机器人任务详情',
      add: '添加机器人任务账号',
      edit: '编辑机器人任务Account'
    }
  },
  tab: 'RPA',
  label: {
    job: '职位',
    resume: '简历',
    '51job': '前程无忧',
    liepin: '猎聘',
    zhilian: '智联',
    rpaList: 'RPA 列表',
    legacyTasks: '旧版任务',
    newTasks: '新版任务',
    accountInfo: '用户信息',
    bind: '绑定菁客',
    addAccount: '新增账号',
    editAccount: '编辑账号',
    memberName: '51会员名称',
    companyName: '公司名称',
    account: '平台账号',
    password: '平台密码',
    featureType: '功能',
    isEnabled: '是否启用',
    channel: '平台',
    postingJob: '发布职位',
    resumeDownload: '下载简历',
    resumeDownloadListTitle: '简历下载',
    restarting: '正在重启',
    ipAddress: '内网IP',
    date: {
      days: '天',
      hour: '小时',
      min: '分钟'
    },
    postedJob: {
      new: '新发布的职位',
      close: '关闭的职位'
    },
    inQueueJob: {
      new: '待发布的职位',
      close: '待关闭的职位'
    },
    downloadResume: {
      downloaded: '简历下载',
      handled: '简历上传',
      gap: '简历未上传'
    },
    bot: {
      totalBots: '机器总数',
      currentBots: '当前运行数量',
      needVerifyBots: '需要验证数量',
      errorBots: '错误数量'
    },
    table: {
      header: {
        companyAccount: '公司/用户',
        channel: '渠道',
        type: '类型',
        status: '状态',
        action: '操作',
        view: '查看',
        onOff: 'On/Off',
        resumeName: '简历名称',
        candidateName: '求职者名称',
        reqId: '职位ID',
        downloadTime: '下载时间',
        uploadToAjingaTime: '上传至菁客时间',
        emailSubject: '邮件标题'
      },
      date: {
        days: '天',
        hour: '小时',
        min: '分钟'
      }
    },
    currentStatus: '当前状态: {status}',
    jobCompany: '简历职位所属公司',
    ignoreNoIdJob: '忽略无AJINGA职位ID/无第三方ID的职位',
    importResumeToClosedJob: '导入简历到已关闭职位'
  },
  placeholder: {
    searchCompanyById: '输入 ID 以搜索',
    salary: {
      min: '最低薪资',
      max: '最高薪资'
    },
    search: {
      taskStatus: '账号状态',
      launcherStatus: '机器人状态',
      featureType: '功能类型',
      channel: '渠道',
      company: '公司',
      keywords: '账号或公司名称'
    }
  },
  btn: {
    status: {
      enable: '启用',
      disable: '禁用'
    },
    add: '添加账号',
    restart: '重启',
    needOperate: '需要操作',
    download: '下载',
    return: '返回'
  },
  message: {
    pleaseSelect: '请选择',
    pleaseInput: '请输入',
    operatorConfirmMessage: '您确认进行操作？',
    operatorConfirm: '确认',
    operatorCancel: '不用了',
    pleaseSelectCompany: '请先选择公司',
    ipAddressError: 'IP 地址错误'
  },
  dayRange: {
    0: '今天',
    7: '7 天',
    15: '15 天',
    30: '30 天'
  },
  featureType: {
    DOWNLOAD_RESUME: '下载简历',
    JOB_POSTING: '发布职位',
    SHI_XI_SENG_SAVE_RESUME: '下载实习僧简历',
    GET_JOB_DATA: '同步职位PV/UV'
  },
  channelName: {
    JOB_51: '前程无忧',
    ZHI_LIAN: '智联',
    LIE_PIN: '猎聘',
    SHI_XI_SENG: '实习僧',
    YI_MAI_TONG_DAO: '医脉同道'
  },
  actionType: {
    START: '开启',
    STOP: '关闭',
    RESTART: '重启',
    VERIFY: '验证'
  },
  taskStatus: {
    ON: '已启用',
    OFF: '已关闭',
    DISABLED: '不可用'
  },
  launcherDisplayStatus: {
    ACTIVE: '进行中',
    IN_QUEUE: '等待中',
    WAIT_VERIFY: '需要验证',
    CLOSED: '关闭',
    EXITED_ERROR: '异常关闭',
    UNKNOWN: '未知'
  }
}
